module.exports = __webpack_public_path__ + "static/media/escaner-modo-almacen.506211ec.png";